import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pecrId: null,
};

export const pecrDataSlice = createSlice({
  name: 'pecrData',
  initialState,
  reducers: {
    pecrData: (state, action) => {
      state[action.payload.key] = action.payload.value;
    },
  },
});

// Action creators are generated for each case reducer function
export const { pecrData } = pecrDataSlice.actions;

export default pecrDataSlice.reducer;
